import { Button, Card, Grid, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AppsOutlined as AppsOutlinedIcon } from '@material-ui/icons';
import dayjs from 'dayjs';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import LocalizationContext from '../contexts/LocalizationContext';
import Logo from '../images/Logo';
import { AccountContext } from './apps/account/context/AccountProvider';
import Notifications from './main/Notifications';
import SelectLanguage from './main/SelectLanguage';
import { RiShieldUserLine } from 'react-icons/ri';

const useStyles = makeStyles((theme) => ({
    portalContainer: {
        position: 'fixed',
        top: '0',
        right: '0',
        left: '0',
        width: '100%',
        borderRadius: 0,
        padding: '8px 0',
        display: 'flex',
        fontFamily: theme.typography.fontFamily,
        zIndex: 2,
    },
    navBar: {
        boxShadow: '0 0.25rem 0.75rem rgba(0, 0, 0, 0.05)',
        backgroundColor: 'white',
    },
    navBarDev: {
        boxShadow: '0 0.25rem 0.75rem #ffe6cc',
        backgroundColor: '#ff9933',
    },
    navBartest: {
        boxShadow: '0 0.25rem 0.75rem #ffe6ff',
        backgroundColor: '#ffccff',
    },
    navbarAction: {
        width: '40px',
        height: '40px',
        margin: 'auto 3px',
        borderRadius: '40px',
    },
    navbarButton: {
        minWidth: 'unset',
        width: '40px',
        height: '40px',
    },
    profilePicture: {
        width: '50px',
        height: '50px',
        borderRadius: '50px',
        imageRendering: '-webkit-optimize-contrast',
    },
    actionIcons: {
        display: 'flex',
        margin: 'auto -3px',
    },
    title: {
        textAlign: 'center',
        fontSize: '32px',
    },
    redBlink: {
        animationName: '$blinker',
        animationDuration: '3s',
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite',
        color: 'red',
    },
    '@keyframes blinker': {
        from: { opacity: 1 },
        to: { opacity: 0 },
    },
}));

const NavMenu = ({ onLanguageChanged }) => {
    const classes = useStyles();
    const account = useContext(AccountContext);
    let environment = window.location.hostname;
    const localization = useContext(LocalizationContext);

    return (
        <>
            <Card
                className={
                    environment.includes('portal-dev.bba.ca')
                        ? `${classes.navBarDev} ${classes.portalContainer}`
                        : environment.includes('portal-tst.bba.ca')
                        ? `${classes.navBartest} ${classes.portalContainer}`
                        : `${classes.navBar} ${classes.portalContainer}`
                }>
                <Grid container>
                    <Grid item lg={2} xs={2}>
                        <Link to={'/'}>
                            <Logo height={40} color='#002952' style={{ marginLeft: '50%', marginTop: '6px' }} />
                        </Link>
                    </Grid>
                    <Grid item lg={8} xs={3} className={classes.title}>
                        {account.notificationsAndToken.showExpirationNotification &&
                            account.notificationsAndToken.expirationMinutes <= 10 && (
                                <span className={account.notificationsAndToken.expirationMinutes <= 5 ? classes.redBlink : ''}>
                                    Expiration: {dayjs(account.notificationsAndToken.expirationDatetime).fromNow()}
                                </span>
                            )}
                        {environment.includes('portal-dev.bba.ca')
                            ? localization.strings.environmentDev
                            : environment.includes('portal-tst.bba.ca')
                            ? localization.strings.environmentTest
                            : ''}
                    </Grid>
                    <Grid item lg={2} xs={6} className={classes.actionIcons}>
                        <SelectLanguage onLanguageChanged={onLanguageChanged} className={classes.navbarAction} />
                        <AppsAction />
                        {account.account && <Notifications className={classes.navbarAction} />}
                        <AccountAction />
                    </Grid>
                </Grid>
            </Card>
        </>
    );
};

const AppsAction = () => {
    const classes = useStyles();

    return (
        <Link to='/' className={classes.navbarAction}>
            <Button variant='text' className={classes.navbarButton}>
                <AppsOutlinedIcon style={{ fontSize: '24px' }} />
            </Button>
        </Link>
    );
};

const AccountAction = () => {
    const classes = useStyles();
    const account = useContext(AccountContext);
    const localization = useContext(LocalizationContext);

    const isAdminAccount = /^r[a-z]{4}[0-9]{4,5}$/i.test(account.account?.username || '');

    if (account.account)
        return (
            <Link to='/account' className={classes.navbarAction} style={{ marginLeft: '20px', width: '50px', height: '50px' }}>
                <Tooltip title={account.account.username || ''}>
                    <Button variant='text' className={classes.navbarButton} style={{ width: '50px', height: '50px' }}>
                        { !isAdminAccount && (
                        <img
                            className={classes.profilePicture}
                            src={account.account.profilePicture || '/images/empty-profile.jpg'}
                            alt={localization.strings.account.account}
                        />
                        )}
                        { isAdminAccount && (
                        <RiShieldUserLine className={`${classes.profilePicture}`} style= {{ color: '#c0392b' }} />
                        )}
                    </Button>
                </Tooltip>
            </Link>
        );
    return <></>;
};

export default NavMenu;
